import { ROLE_COLOURS } from './nodes/nodeConfig';

/**
 * Persistent legend bar showing the four node role types.
 * BR-14: REQ-10
 */
export function JourneyLegend() {
  const items = [
    { role: 'entry', label: 'Entry (DNIS)', colour: ROLE_COLOURS.entry },
    { role: 'routing', label: 'Routing (Menu / Intent)', colour: ROLE_COLOURS.routing },
    { role: 'resolution', label: 'Resolution (Queue / Transfer)', colour: ROLE_COLOURS.resolution },
    { role: 'condition', label: 'Condition (Hours / Holiday)', colour: ROLE_COLOURS.condition },
  ];

  return (
    <div style={{ display: 'flex', gap: 20, padding: '8px 16px', background: '#F8FAFC', borderBottom: '1px solid #E2E8F0', fontSize: 12 }}>
      {items.map((item) => (
        <span key={item.role} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ width: 10, height: 10, borderRadius: '50%', background: item.colour, display: 'inline-block' }} />
          {item.label}
        </span>
      ))}
    </div>
  );
}
